import React from "react";
import { Col, Row } from "antd";

const FundInnerDetails = ({
  strategyValue,
  aumValue,
  subSpecialities
}) => {
  return (
    <Row className="text-center">

      <Col span={8}>
        <div className="Fund-FontSize">{`${aumValue !== undefined ? aumValue : "N/A"}`}</div>
        <h4>AUM</h4>
      </Col>
      <Col span={8} style={{borderLeft : "2px solid #c1c1c1", borderRight : "2px solid #c1c1c1"}}>
        <div className="Fund-FontSize">{strategyValue ? strategyValue : "N/A"}</div>
        <h4>Strategy</h4>
      </Col>
      <Col span={8}>
        <div className="Fund-FontSize">{subSpecialities ? subSpecialities : "N/A"}</div>
        <h4>Sub Strategy</h4>
      </Col>

      
    </Row>
  );
};

export default FundInnerDetails;
